import {HttpErrorResponse} from '@angular/common/http';

export function httpErrorMessage(err: unknown, fallback: string): string {
  if (!(err instanceof HttpErrorResponse)) {
    return fallback;
  }

  const body = err.error;
  if (typeof body === 'string' && body.trim().length > 0) {
    return body.trim();
  }
  if (body && typeof body === 'object') {
    const detail = (body as {detail?: unknown; message?: unknown; error?: unknown}).detail
      ?? (body as {message?: unknown}).message
      ?? (body as {error?: unknown}).error;
    if (typeof detail === 'string' && detail.trim().length > 0) {
      return detail.trim();
    }
  }

  if (err.status === 413) {
    return 'Fichier trop volumineux pour l\'envoi. Réduisez la taille du fichier et réessayez.';
  }

  return fallback;
}
